module.exports = __webpack_public_path__ + "img/Germany.5e113289.png";